
define('tpl!taoQtiItem/qtiXmlRenderer/tpl/outcomeDeclaration', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += " ";
  stack1 = (helper = helpers.join || (depth0 && depth0.join),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.attributes), "=", " ", "\"", options) : helperMissing.call(depth0, "join", (depth0 && depth0.attributes), "=", " ", "\"", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  return buffer;
  }

function program3(depth0,data) {
  
  
  return "/>\n";
  }

function program5(depth0,data) {
  
  var buffer = "", stack1;
  buffer += ">\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.defaultValue)),stack1 == null || stack1 === false ? stack1 : stack1.length), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</outcomeDeclaration>";
  return buffer;
  }
function program6(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "<defaultValue>\n        ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.defaultValue), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</defaultValue>\n    ";
  return buffer;
  }
function program7(depth0,data) {
  
  var buffer = "";
  buffer += "<value>"
    + escapeExpression((typeof depth0 === functionType ? depth0.apply(depth0) : depth0))
    + "</value>\n        ";
  return buffer;
  }

  buffer += "\n<outcomeDeclaration";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.attributes), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.empty), {hash:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  return buffer;
  });
});

